<template>
  <div class="zlDiscuss">
    <div class="discuss_list_wrap" v-if="!showEditor && !showDetails" v-loading="discussLoading">
      <div v-if="discussList && discussList.length>0" class="discuss_tab">
        <p class="discuss_tab_p" v-for="(item,index) in tabList" :key="index" @click="activeThis(index)"
           :class="{activeStyle:type === index}">
          {{item}}
        </p>
      </div>
      <div class="discussListBox" v-if="discussList && discussList.length>0">
        <div style="display: flex;margin-bottom: 10px;align-items: center;justify-content: space-between;">
          <el-switch v-model="myContent" @change="getNoteList" inactive-text="查看全部" active-text="只看我的"></el-switch>
          <el-button size="mini" type="primary" @click="showEditor = true">发起讨论</el-button>
        </div>
        <!-- 讨论卡片 -->
        <div class="discuss_item" v-for="(item,index) in discussList" :key="index"
             @click="getDiscussionAndReply(item)">
          <div class="head_portrait">
            <img v-if="item.userType==0" :src="teacherHead"/>
            <img v-else-if="item.userType==1" :src="teacherHead"/>
            <img v-else-if="item.userType==2" :src="item.anonymous==0?anonymousHead:studentHead"/>
            <img v-else :src="anonymousHead"/>
          </div>
          <div class="list_info">
            <div class="list_info_line">
              <div class="list_info_line_box">
                <span class="user_name">{{item.anonymous==0?'匿名用户':item.userName}}</span>
              </div>
              <div class="list_info_line_box">
                <span class="user_type" v-if="item.userType==0||item.userType==1">教师</span>
              </div>
              <div class="list_info_line_box">
                <span class="time">{{item.createTimeStr}}</span>
              </div>
              <div class="list_info_line_box">
                <span class="status" v-if="item.repliedOrParticipation">{{item.repliedOrParticipationName}}</span>
              </div>
            </div>
            <div class="list_info_line">
              <p>{{item.theme}}</p>
            </div>
            <div class="list_info_line">
              <div class="chapter" v-if="item.catalogId!=''&&item.discussionAreaId!=3">
                <img src="/static/images/study/icon/zhangjie.png"/>
                <span>{{item.catalogId!=null?item.catalogName:'全部教学章节'}}</span>
              </div>
              <div class="operation">

                <span class="operation_item" title="编辑" @click.stop="getDiscussionToEdt(item)"
                      v-if="item.createUser === Number(userId)">
                   <svg style="width: 14px;height: 14px;" class="icon svg-icon" aria-hidden="true">
                      <use xlink:href="#icon-xiugai"></use>
                   </svg>
                </span>
                <span class="operation_item" title="浏览">
                   <svg style="width: 14px;height: 14px;" class="icon svg-icon" aria-hidden="true">
                      <use xlink:href="#icon-liulan"></use>
                   </svg>
                   <span>{{(item.viewCount&&item.viewCount!=='null')?item.viewCount:0}}</span>
                </span>
                <span class="operation_item" title="点赞" @click.stop="discussionSamePraise(item)">
                   <svg style="width: 14px;height: 14px;" class="icon svg-icon" aria-hidden="true">
                      <use xlink:href="#icon-dianzan"></use>
                   </svg>
                   <span>{{(item.praiseCount&&item.praiseCount!=='null')?item.praiseCount:0}}</span>
                </span>
                <span class="operation_item" title="消息">
                   <svg style="width: 14px;height: 14px;" class="icon svg-icon" aria-hidden="true">
                      <use xlink:href="#icon-xiaoxi"></use>
                   </svg>
                   <span>{{(item.replyCount&&item.replyCount!=='null')?item.replyCount:0}}</span>
                </span>

              </div>
            </div>
          </div>
          <!-- <span class="el-icon-close respective_region" v-if="item.isCreateUser||item.isClassTeacher" @click.stop="deleteDiscuss(item)"></span> -->
          <div class="is_top" v-if="item.roofPlacement">
            <img src="/static/images/study/icon/zhiding.png"/>
          </div>
        </div>
      </div>
      <div v-else class="isEmpty">
        <el-empty :image-size="100" description=" ">
          <p>暂无内容，快来<span style="color: #0e9aff;cursor: pointer;" @click="setStatus">发起讨论</span>吧</p>
        </el-empty>
      </div>
    </div>
    <div class="note-text" v-else-if="showEditor">
      <p class="note-text-p"><i>*</i><span>主题</span></p>
      <el-input
        type="textarea"
        placeholder="请输入主题"
        maxlength="300"
        show-word-limit
        v-model.trim="discussDetails.theme">
      </el-input>
      <p class="note-text-p"><span>内容</span></p>
      <editor v-model.trim="discussDetails.content" height="200px" :toolMenus="editorMenus"
              :onlyKey="discussId + 'zlDiscuss'"></editor>
      <p class="note-text-p"><span>是否置顶</span></p>
      <el-switch
        v-model="discussDetails.roofPlacement" :active-value="1" :inactive-value="0">
      </el-switch>
      <p class="note-text-p"><span>是否匿名</span></p>
      <el-switch
        v-model="discussDetails.anonymous" :active-value="0" :inactive-value="1">
      </el-switch>
      <div class="bottombtn">
        <el-button size="mini" type="primary" @click="cancelEditor">返 回</el-button>
        <el-button size="mini" type="primary" @click="addNote()">保 存</el-button>
      </div>
    </div>
    <div class="note-show" v-else-if="showDetails">
      <div class="note-goback">
        <span></span>
        <el-button size="mini" type="primary" @click="cancelEditor">返 回</el-button>
      </div>
      <discussDetail :discussId="discussId" :query="query" @getDiscussionToEdt="getDiscussionToEdt"></discussDetail>
    </div>
  </div>
</template>

<script>
  /**
   *  IT讨论组件。
   *    sq 2023.4.16
   */
  import * as api from "@/api/discussApi";
  import editor from '../../../components/wjlEditor/index.vue';
  import discussDetail from './discussDetail.vue'

  export default {
    name: "zlDiscuss",
    components: {editor, discussDetail},
    props: {
      query: {
        type: Object,
        default: () => {
        },
      }
    },
    data() {
      return {
        userType: sessionStorage.getItem('userType'),
        userId: sessionStorage.getItem('userId'),
        discussLoading: false,
        teacherHead: '/static/images/study/icon/teacher.png',
        studentHead: '/static/images/study/icon/student.png',
        anonymousHead: '/static/images/study/icon/niming.png',
        // 讨论需要的参数
        discussDetails: {
          roofPlacement: 0,  // 是否置顶
          anonymous: 0,  // 是否匿名
          theme: '',  // 主题
          content: '',  // 笔记内容
        },

        // 查看详情
        showDetails: false,
        // 编辑
        showEditor: false,
        discussId: '',
        createTimeStr: '',
        learnToolReplies: [],  // 回复的数据
        // 查询
        myContent: false,
        type: 0,   // 0最新发表 1浏览数 2点赞数  3回复数
        tabList: ['最新发表', '浏览数', '点赞数', '回复数'],
        discussList: [],
        //
        editorMenus: [ // 富文本菜单栏
          "bold", // 加粗
          "underline", // 下划线
          "italic", // 斜体
          "strikeThrough", // 横穿线
          "foreColor", // 文字颜色
          "backColor", // 背景色
					"code",
          "image", // 图片
        ],

      }
    },
    created() {
      this.discussLoading = true;
      this.getNoteList()
    },
    methods: {
      // 获取讨论
      getNoteList() {
        let obj = {
          courseId: this.query.courseId,
          classId: this.query.classId,
          catalogId: this.query.catalogId,
          type: this.type,    // 0最新发表 1浏览数 2点赞数  3回复数
          name: '',  // 主题筛选
          myContent: this.myContent, //只看我的
          repliedOrParticipationFlag: 0, //老师已答复、参与
          discussionAreaId: 3, //1全部、2老师、3课堂
          pageSize: 2000,
          pageNum: 1
        }
        api.getDiscussList(obj).then(res => {
          if (res.code == 0) {
            if (res.data) this.discussList = res.data.list;

          }
        }).catch(error => console.log(error)).finally(() => this.discussLoading = false)
      },
      // 修改讨论
      getDiscussionToEdt(item) {
        let obj = {
          courseId: this.query.courseId,
          classId: this.query.classId,
          catalogId: this.query.catalogId,
          id: item.id,
        }
        api.getReplyList(obj).then(res => {
          if (res.code == 0) {
            if (res.data)

              this.discussDetails.theme = res.data.theme;
            this.discussDetails.content = res.data.content;
            this.discussDetails.anonymous = res.data.anonymous;
            this.discussDetails.roofPlacement = res.data.roofPlacement ? 1 : 0;
            this.learnToolReplies = res.data.learnToolReplies;
            this.createTimeStr = res.data.createTimeStr;
            this.discussId = item.id;
            this.showDetails = false;
            this.showEditor = true;

          }
        }).catch(error => console.log(error)).finally(() => this.discussLoading = false)
      },
      //  预览 +1
      getDiscussionAndReply(item) {
        this.discussId = item.id;
        let obj = {
          learnId: item.id,
          type: 0
        }
        api.getDiscussDetail(obj).then( r =>{
          if (r.code == 0){
            this.showEditor = false;
            this.showDetails = true;
            this.$set(item, 'viewCount', Number(item.viewCount) + 1);
          }
        })
      },

      // 给讨论点赞
      discussionSamePraise(item) {
        item.isPraise = !item.isPraise
        let obj = {
          learnId: item.id,
          isAdd: item.isPraise,
        }
        api.likedDiscuss(obj).then(rs => {
          if (rs.code == 0) {
            item.isPraise ? item.praiseCount++ : item.praiseCount--

          } else {
            this.$messageError(rs.msg)

          }
        }).catch(() => {
        })
      },

      // 新增一条
      addNote() {
				if(!this.discussDetails.theme) return this.$messageWarning("请输入主题");
        let request = null
        if (this.discussId) {
          let obj = {
            id: this.discussId,
            discussionAreaId: 3,  // 所属区域 、
            courseId: this.query.courseId,
            catalogId: this.query.catalogId,
            classId: this.query.classId,
            resourceId: this.query.id,
            resourceType: 9,
            catalogIds: this.query.catalogId,
            //
            ...this.discussDetails,
          }
          request = api.publishDiscussUpdate(obj)

        } else {
          let obj = {
            discussionAreaId: 3,  // 所属区域 、
            courseId: this.query.courseId,
            catalogId: this.query.catalogId,
            classId: this.query.classId,
            resourceId: null,
            resourceType: null,
            catalogIds: this.query.catalogId,
            //
            ...this.discussDetails,
          }
          request = api.publishDiscuss(obj);
        }
        request.then(rs => {
          if (rs.code == 0) {
            this.cancelEditor();
            this.getNoteList();
            this.$messageSuccess('发表成功')
          } else {
            this.$messageError(rs.msg)
          }
        }).catch(err => {
          console.log(err)
        })
      },
      activeThis(index) {
        this.type = index;
        this.getNoteList();
      },
      setStatus() {
        this.showEditor = true;
        this.discussDetails = {
          roofPlacement: 0,  // 是否置顶
          anonymous: 0,  // 是否匿名
          theme: '',  // 主题
          content: '',  // 笔记内容
        }
        this.discussId = '';
      },
      cancelEditor() {
        this.showEditor = false;
        this.showDetails = false;
        this.discussDetails = {
          roofPlacement: 0,  // 是否置顶
          anonymous: 0,  // 是否匿名
          theme: '',  // 主题
          content: '',  // 笔记内容
        }
        this.discussId = '';
				this.getNoteList()
      },
    }

  }
</script>

<style scoped lang="scss">
  .zlDiscuss {
    height: 100%;
    width: 100%;
    /*display: flex;*/
    /*flex-direction: column;*/
    overflow-y: auto;

    .discuss_list_wrap {
      .discussListBox {
        margin: 10px;
        box-sizing: border-box;

        .discuss_item {
          display: flex;
          width: 100%;
          padding: 10px 10px 10px 0;
          border: 1px solid rgb(230, 230, 230);
          border-radius: 4px;
          margin-bottom: 16px;
          box-sizing: border-box;
          position: relative;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

          &:hover {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
          }

          .head_portrait {
            width: 80px;
            min-width: 80px;
            text-align: center;

            img {
              width: 40px;
            }
          }

          .list_info {
            flex: 1;

            .list_info_line {
              width: 100%;

              &:nth-child(1) {
                margin-bottom: 24px;

                .user_name {
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(51, 51, 51, 1);
                }

                .user_type {
                  line-height: 18px;
                  background: rgba(232, 242, 255, 1);
                  border-radius: 2px;
                  padding: 0 5px;
                  margin-left: 8px;
                  font-size: 12px;
                  font-weight: 400;
                  color: rgba(83, 151, 247, 1);
                }

                .time {
                  font-size: 12px;
                  font-weight: 400;
                  color: rgba(153, 153, 153, 1);
                  margin: 0 40px;
                }

                .status {
                  line-height: 18px;
                  border: 1px solid rgba(83, 151, 247, 1);
                  border-radius: 2px;
                  padding: 0 6px;
                  font-size: 12px;
                  font-weight: 400;
                  color: rgba(83, 151, 247, 1);
                }
              }

              &:nth-child(2) {
                p {
                  max-width: 900px;
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(51, 51, 51, 1);
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }

              &:nth-child(3) {
                margin-top: 20px;

                .chapter {
                  float: left;
                  display: flex;
                  align-items: center;

                  img {
                    width: 14px;
                  }

                  span {
                    font-size: 12px;
                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                    margin-left: 4px;
                  }
                }

                .operation {
                  display: flex;
                  justify-content: flex-end;
                }
              }

              .list_info_line_box {
                display: inline-block;
              }
            }
          }

          .respective_region {
            position: absolute;
            right: 14px;
            top: 16px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(83, 151, 247, 1);
          }

          .is_top {
            position: absolute;
            left: -1px;
            top: 0;

            img {
              width: 60px;
            }
          }
        }
      }
    }

    .discuss_tab {
      display: flex;
      align-items: center;
      font-size: 12px;
      margin: 10px;

      .discuss_tab_p {
        position: relative;
        text-align: center;
        cursor: pointer;
        padding: 5px 17px;
        color: #999999;
      }

      .activeStyle {
        background: rgba(83, 151, 247, 1);
        border-radius: 16px;
        color: #fff;
      }
    }

    .note-text {
      padding: 10px;

      .note-text-p {
        margin: 10px 0 5px;
        font-size: 12px;

        i {
          color: red;
          display: inline-block;
          margin-right: 7px;
        }
      }

      .bottombtn {
        padding: 14px 20px;
        text-align: center;
      }

    }

    .note-show {
      padding: 10px;
    }

    .operation_item {
      margin: 0 10px;
      color: #acacac;
      display: flex;
      align-items: center;
      font-size: 12px;
      cursor: pointer;

      svg {
        margin-right: 5px;
        fill: #acacac;
      }
    }

    .note-goback {
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .isEmpty {
      font-size: 12px;
      text-align: center;
      color: #cccccc;
      margin-top: 40%;

      p {
        margin-bottom: 10px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/IT/components/zlDiscuss.vue